export const CHAT_ACTIONS = [
    { name: 'New user set up', text: 'Invite a new employee into the system.', enum: 'onboarding' },
    { name: 'User offboarding', text: 'Remove access and deactivate an employee account.', enum: 'offboarding' },
    { name: 'Suspend user access', text: 'Temporarily disable account access.', enum: 'suspending' },
	{ name: 'Ask Sofia', text: 'Ask Sofia', enum: 'ask_sophia' }
    // { name: 'Change user access', text: 'Change user access.', enum: 'changeAccess' },
    // { name: 'Set up account', text: 'Create user account.', enum: 'setUpAccount' },
]